<template>
    <div class="flex-c">
        <div v-for="(item,index) in stepData" :key="index" class="step-wrapper">
            <div class="content-wrapper">
                <div class="circle" :class="index < activeStep ?'circle-active' : ''">{{index+1}}</div>
                <div class="title" :class="index < activeStep ?'title-active' : ''">{{item.title}}</div>
            </div>
            <div class="line" v-if="index !== stepData.length -1"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "e-steps",
        props:{
            stepData:Array,
            activeStep:{
                type:Number,
                default:1
            },
        },

    }
</script>

<style scoped lang="scss">
    .step-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        .content-wrapper{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .circle{
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                border-radius: 50%;
                border: 1px solid #D9D9D9;
                color: #C5C5C5;
            }
            .circle-active{
                background-color: #2587FF;
                color: #FFF;
                border: none;
            }
            .title{
                display: inline-block;
                font-size: 14px;
                color: #999;
                margin-top: 10px;
            }
            .title-active{
                color: #333;
            }
        }
        .line{
            border: 1px solid #2587FF;
            width: 150px;
            height: 0;
            margin: 0 13px 28px 13px;
        }
    }

</style>